import React from 'react';
import { TFactoryOrderButton } from 'types';
import { Button } from '../../button';

export default function FactoryOrderButton(props: TFactoryOrderButton) {
  return (
    <Button
      variant={'teal'}
      onClick={() => props.setIsFactoryOrderOpen(!props.isFactoryOrderOpen)}
      disabled={props.isVehicleReserved || props.isReservationInWaiting || props.isDisabled}
      className="items-center font-extrabold enabled:hover:bg-turquoise"
      appearance="outline"
    >
      <span>Bestill bil fra fabrikk</span>
    </Button>
  );
}
